import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import { MathJaxContext } from 'better-react-mathjax';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/dashboard';
import GlobalErrorBoundary from './components/GlobalErrorBoundary';
import { isAuthenticated } from './utils/auth';
import './App.css';
import api from './api/axios';

// 性能监控：保留性能监控器本体；移除模拟“性能测试”自动执行逻辑

const { Content } = Layout;

// 🔧 私有路由组件 - 每次渲染时重新检查认证状态
const PrivateRoute = ({ children }) => {
  // 每次组件渲染时都会重新调用 isAuthenticated()
  const authenticated = isAuthenticated();
  console.log('PrivateRoute 认证检查:', authenticated);
  return authenticated ? children : <Navigate to="/login" replace />;
};

// MathJax 配置
const mathJaxConfig = {
  loader: { load: ['[tex]/mhchem', '[tex]/html'] },
  tex: {
    packages: { '[+]': ['mhchem', 'html'] },
    inlineMath: [['$', '$'], ['\\(', '\\)']],
    displayMath: [['$$', '$$'], ['\\[', '\\]']],
    processEscapes: true,
    processEnvironments: true,
    tags: 'ams',
    macros: {
      RR: '{\\bf R}',
      bold: ['{\\bf #1}', 1]
    }
  },
  options: {
    enableMenu: false, // 禁用右键菜单
    skipHtmlTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code'],
    ignoreHtmlClass: 'no-mathjax'
  }
};

const App = () => {

  // 单点登录心跳：检测token被其他设备挤下线
  useEffect(() => {
    let timerId = null;

    const checkSession = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;
      try {
        await api.get('/auth/verify');
      } catch (e) {
        if (e?.response?.status === 401) {
          try {
            const msg = e.response?.data?.message || e.response?.data || '登录已失效，请重新登录';
            sessionStorage.setItem('auth:logoutReason', typeof msg === 'string' ? msg : '登录已失效，请重新登录');
          } catch (_) {}
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
        }
      }
    };

    const tick = () => {
      if (document.visibilityState !== 'visible') return;
      checkSession();
    };

    timerId = setInterval(tick, 15000);
    checkSession();

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkSession();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      if (timerId) clearInterval(timerId);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  return (
    <MathJaxContext config={mathJaxConfig}>
      <GlobalErrorBoundary>
        <Layout className="app-container">
          <Content>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/dashboard"
              element={<PrivateRoute><Dashboard /></PrivateRoute>}
            />
            <Route
              path="/account/agency"
              element={<PrivateRoute><Dashboard /></PrivateRoute>}
            />
            <Route
              path="/account/supervisor"
              element={<PrivateRoute><Dashboard /></PrivateRoute>}
            />
            <Route
              path="/account/students/trial"
              element={<PrivateRoute><Dashboard /></PrivateRoute>}
            />
            <Route
              path="/account/students/formal"
              element={<PrivateRoute><Dashboard /></PrivateRoute>}
            />
            <Route
              path="/account/card"
              element={<PrivateRoute><Dashboard /></PrivateRoute>}
            />
            <Route
              path="/account/manage"
              element={<PrivateRoute><Dashboard /></PrivateRoute>}
            />
            <Route
              path="/studentAccount/trialAccount"
              element={
                <PrivateRoute>
                  <Navigate to="/account/students/trial" replace />
                </PrivateRoute>
              }
            />
            <Route
              path="/studentAccount/officialAccount"
              element={
                <PrivateRoute>
                  <Navigate to="/account/students/formal" replace />
                </PrivateRoute>
              }
            />
            <Route path="/" element={
              isAuthenticated() ? <Navigate to="/account/students/formal" replace /> : <Navigate to="/login" replace />
            } />
            <Route path="*" element={<Navigate to="/account/students/formal" replace />} />
          </Routes>
        </Content>
      </Layout>
    </GlobalErrorBoundary>
    </MathJaxContext>
  );
};

export default App; 
